<template>
  <div id="contenedor-eliminar-contrato-relacionado">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Contrato Relacionado </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el contrato relacionado? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarContratoRelacionado"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratosRelacionados from './mixContratosRelacionados';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarContratoRelacionado',
  mixins: [mixContratosRelacionados],
  props: {
    contratoRelacionadoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
